export enum GamingHistoryType {
    UserHistory = 1,
    SessionHistory = 2,
    JackpotBetsGamingHistory = 3
}
